// React
import React from "react";
// React
// CSS
import styles from "./Spinner.module.css";
// CSS

// Themes
import { themeColor } from "../../Constants/constants";
// Themes

type SpinnerProps = {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
};

const Spinner: React.FunctionComponent<SpinnerProps> = ({
  className,
  color,
  style,
}) => {
  return (
    <span
      className={`${styles.spinnerContianer} `}
      style={{
        background: color || themeColor,
        ...style,
      }}
    >
      <span
        className={`${styles.loader} ${className} flex align-items-center justify-content-center`}
      ></span>
    </span>
  );
};

export default Spinner;
